// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

sortSelectStyles.select = {
    mergeCss: true,
    sizeVariant: "small",
    labelProps: {
        weight: fontConfig.weight.regular,
        css: css`
            line-height: ${fontConfig.lineHeight.small};
            padding-top: 0;
        `,
    },
    cssOverrides: {
        formField: css`
            align-items: center;
            width: 250px;
            ${xScreen("lte", "md")} {
                width: 230px;
            }
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
        formInputWrapper: css`
            width: 100%;
            flex-grow: 1;
            min-width: 200px;
            ${xScreen("lte", "md")} {
                min-width: 175px;
            }
            ${xScreen("lte", "sm")} {
                min-width: 150px;
            }
            ${xScreen("lte", "xs")} {
                min-width: auto;
            }
        `,
    },
};
